export class AuthRole {

}
